// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__OYFgN","titleContainer":"styles_titleContainer__N1eEy","subTitle":"styles_subTitle__gcvTc","title":"styles_title__20JPT"};